/* @flow */

import * as types from 'src/shared/app/notification/action/uiNotificationActionTypes';
import { getNotificationId } from 'src/shared/app/notification/util/notificationUtil';
import { createReducer } from 'src/shared/core/util/reducerUtils';

/*
|------------------------------------------------------------------------------
| INITIAL STATE
|------------------------------------------------------------------------------
*/

const initialState = {
  queue: [],
};

/*
|------------------------------------------------------------------------------
| REDUCERS
|------------------------------------------------------------------------------
*/

const _queueNotification = (state: Object, action: Object): Object => {
  const { queue } = state;
  const { notification: newNotification } = action;

  if (
    queue.find(
      (notification) =>
        getNotificationId(notification) === getNotificationId(newNotification),
    )
  ) {
    return state;
  }
  return {
    ...state,
    queue: [...queue, newNotification],
  };
};

const _dismissNotification = (state: Object, action: Object): Object => {
  const { queue } = state;
  const { notification } = action;
  const id =
    typeof notification === 'string'
      ? notification
      : getNotificationId(notification);
  const index = queue.findIndex((n) => getNotificationId(n) === id);

  if (index < 0) {
    return state;
  }
  return {
    ...state,
    queue: [...queue.slice(0, index), ...queue.splice(index + 1)],
  };
};

/*
|------------------------------------------------------------------------------
| REDUCER
|------------------------------------------------------------------------------
*/

export default createReducer(initialState, {
  [types.QUEUE_NOTIFICATION]: _queueNotification,
  [types.DISMISS_NOTIFICATION]: _dismissNotification,
});
